// Shared bits of the US-stocks modal, styled with the `pf` tokens from the
// "Asset modal" design handoff (tailwind.config.js).

export const inputClass =
  "w-full min-h-[36px] rounded-lg border border-pf-input bg-white px-[10px] py-2 text-[13px] text-pf-ink outline-none transition-shadow placeholder:text-pf-faint focus:border-pf-focus focus:shadow-[0_0_0_3px_rgba(111,154,130,0.2)] disabled:bg-pf-subtle disabled:text-pf-soft";

export const BADGE_CLASSES = {
  convert: "bg-pf-convert-bg text-pf-convert-fg",
  buy: "bg-pf-buy-bg text-pf-buy-fg",
  sell: "bg-pf-sell-bg text-pf-sell-fg",
  transfer: "bg-pf-transfer-bg text-pf-transfer-fg",
};

export function Chip({ active, onClick, children }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`whitespace-nowrap rounded-full px-3 py-[6px] text-[12px] font-semibold transition-colors ${
        active ? "bg-pf-active text-white" : "bg-pf-track text-pf-body hover:text-pf-ink"
      }`}
    >
      {children}
    </button>
  );
}

export function Field({ label, wide = false, children }) {
  return (
    <label className={`flex min-w-0 flex-col gap-[5px] ${wide ? "col-span-2" : ""}`}>
      <span className="text-[12px] font-semibold text-pf-soft">{label}</span>
      {children}
    </label>
  );
}

/** Green for gains, red for losses. */
export const toneClass = (n) => (n >= 0 ? "text-pf-accent" : "text-pf-neg");
